import { connect } from "react-redux";
import UserSetting from "../pages/UserSetting";
import { getLocalEDECIntegration } from "../../user/actions";

export default connect(
  (state) => ({
    localEDECIntegration: state.configurator.localEDECIntegration,
  }),
  (dispatch) => ({
    getLocalEDECIntegration: () => {
      dispatch(getLocalEDECIntegration());
    },
  }),
)(UserSetting);
